/* Decorative hero: paint the poster first; never force motion or data use. */
(function () {
  'use strict';
  var video = document.querySelector('video[data-seasonal-autoplay]');
  var poster = document.querySelector('.concept-hero-poster');
  if (!video || !poster) return;
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var connection = navigator.connection;
  var scheduled = false;
  var started = false;
  function permitted() {
    return !motion.matches && !(connection && connection.saveData) && !document.hidden;
  }
  async function start() {
    if (started || !permitted()) return;
    started = true;
    try { await poster.decode(); } catch (_) { /* Native image fallback remains. */ }
    if (!permitted()) { started = false; return; }
    video.poster = poster.currentSrc || poster.src;
    video.muted = true;
    video.autoplay = true;
    video.querySelectorAll('source[data-src]').forEach(function (source) {
      source.src = source.dataset.src;
    });
    video.load();
    video.play().catch(function () { video.dataset.playbackState = 'blocked'; });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 2000 });
    else setTimeout(start, 500);
  }
  video.addEventListener('playing', function () {
    video.classList.add('is-playing');
    video.dataset.playbackState = 'playing';
  });
  video.addEventListener('error', function () {
    video.classList.remove('is-playing');
    video.dataset.playbackState = 'error';
  });
  function updatePreference() {
    if (!permitted()) { video.pause(); video.classList.remove('is-playing'); }
    else if (started) video.play().catch(function () {});
    else if (scheduled) start();
  }
  motion.addEventListener('change', updatePreference);
  if (connection && connection.addEventListener) connection.addEventListener('change', updatePreference);
  document.addEventListener('visibilitychange', updatePreference);
  if (document.readyState === 'complete') setTimeout(schedule, 1500);
  else window.addEventListener('load', function () { setTimeout(schedule, 1500); }, { once: true });
  setTimeout(schedule, 4500);
})();
